module.exports = __webpack_public_path__ + "img/report.0f0a4858.svg";